import { User } from '../planning/user';
import { EcartProtocole } from './ecart-protocole';

export class Tracabilite {
    Code: string;
    CodeOutil: string;
    Comment: string;
    Verificateur: User;

    NombrePotPhase1: number;
    NombrePotPhase2: number;
    NombrePotPhase3: number;

    EcartProtocole: EcartProtocole = new EcartProtocole();

    // DTO
    VerificateurPuid: string;
    // !DTO

    static mapFromJSON(json): Tracabilite {
        const r = new Tracabilite();

        r.Code = json.code;
        r.CodeOutil = json.codeOutil;
        r.Comment = json.comment;
        r.NombrePotPhase1 = json.nombrePotPhase1;
        r.NombrePotPhase2 = json.nombrePotPhase2;
        r.NombrePotPhase3 = json.nombrePotPhase3;
        if (json.verificateur) {
            r.Verificateur = User.mapFromJSON(json.verificateur);
        }
        if (json.ecartProtocole) {
            r.EcartProtocole = EcartProtocole.mapFromJSON(json.ecartProtocole);
        }

        return r;
    }
}
